<script lang="ts" setup>
import FeaturedJobs from '@/components/pages/index/FeaturedJobs.vue';
import Hero from '@/components/pages/index/Hero.vue';
import ogImage from '@images/og-image.png';

export interface ISiteSettings {
  landing_show_recent_jobs: boolean;
}

const { $api } = useNuxtApp()
const config = useRuntimeConfig()
const { t, locale } = useI18n()

const titleByLocale: Record<string, string> = {
    en: 'Samurai Rekrutmen | Work Global, Live Indonesia',
    id: 'Samurai Rekrutmen | Kerja Global, Hidup di Indonesia'
}

const { data: siteSettingData } = await $api.master.getSiteSetting()
const siteSetting = computed<ISiteSettings | undefined>(() => siteSettingData.value?.data)

const title = computed(() => titleByLocale[locale.value] || titleByLocale.en)

const description = computed(() => t('landing_seo_description'))

const url = computed(() => {
    return config.public.jobSeekerUrl
})

const keywords = computed(() => t('landing_seo_keywords'))

/**  Head configurations */
definePageMeta({
    layout: 'landing-page'
})

useSeoMeta({
    title: () => title.value,
    description: () => description.value,
    ogType: 'website',
    ogUrl: () => url.value,
    ogTitle: () => title.value,
    ogDescription: () => description.value,
    ogImage: () => ogImage,
    twitterCard: 'summary_large_image',
    twitterTitle: () => title.value,
    twitterDescription: () => description.value,
    twitterImage: () => ogImage,
    keywords: () => keywords.value
})

useHead(() => ({
    title: title.value,
    titleTemplate: (titleChunk) => titleChunk || '',
    link: [
        {
            rel: 'canonical',
            href: url.value,
        },
        {
            rel: 'preload',
            as: 'image',
            href: '/images/landing-page/hero/hero-bottom-right.webp',
            fetchpriority: 'high',
        },
        {
            rel: 'preload',
            as: 'image',
            href: '/images/landing-page/hero/hero-top-left.webp',
            fetchpriority: 'high',
        },
    ],
}))

// navigateTo('/dashboard')

/**  End of head configurations */
</script>

<template>
    <Navbar></Navbar>
    <div class="">
        <Hero />
        <WhyUs/>
        <TrendingJob />
        <RecentJobs v-if="siteSetting?.landing_show_recent_jobs" />
        <FeaturedJobs />
        <JobSeekerReviews />
        <TrustedCompanies />
        <Cta />
        <Footer />
    </div>
</template>
<style lang="scss" scoped>
    :deep(.v-field__input) {
        @media only screen and (min-width: 768px) {
            font-size: 18px;
            min-height: 50px;
            border-radius: 8px;
            min-block-size:50px !important;
        }

        @media only screen and (min-width: 1360px) {
            font-size: 18px;
            min-height: 63px;
            border-radius: 8px;
            min-block-size:63px !important;
        }
    }
    :deep(.v-btn) {
        @media only screen and (min-width: 768px) {
            font-size: 18px;
            min-height: 50px;
        }

        @media only screen and (min-width: 1360px) {
            font-size: 18px;
            min-height: 63px;
        }
    }
    :deep(.v-btn.v-btn--icon) {
        @media only screen and (min-width: 768px) {
            font-size: 20px;
            min-height: 50px; 
            width: 50px;
        }

        @media only screen and (min-width: 1360px) {
            font-size: 24px;
            min-height: 60px; 
            width: 60px;
        }
    }
</style>
